import React from 'react';

import { Alert, AlertColor, Box, Typography } from '@mui/material';

export function RefundReasonCategorySectionTitle({
  title,
  severity = 'info',
  helperText,
}: {
  title: string;
  severity?: AlertColor;
  helperText?: string;
}) {
  return (
    <Alert
      severity={severity}
      sx={{
        paddingY: 0,
      }}
      icon={false}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
        <Typography variant="body1" fontWeight="medium" color="black">
          {title}
        </Typography>
        {helperText && (
          <Typography variant="body2" fontStyle="italic" color="text.secondary">
            {helperText}
          </Typography>
        )}
      </Box>
    </Alert>
  );
}
